import React from 'react';
const {duelRoundProgress}=require('../utils/duelRoundProgress');
export default function DuelRoundSummary({series,gameId,username}) {
 const progress=duelRoundProgress(series,gameId,username);
 return <section className="duel-round-summary" aria-label="Bu maç sonrası seri durumu">
  <strong>Düello{progress?` · ${progress.number}. maç`:''}</strong>
  <span>{progress?`Bu maç sonrası seri: ${progress.mine}–${progress.opponent}`:'Bu maç sonrası seri skoru kayıtlı değil.'}{progress?.draw?' · Beraberlik':''}{progress?.won?' · Seriyi kazandın':progress?.lost?' · Seriyi kaybettin':''}</span>
 </section>;
}
